import * as React from "react";
import { ProductOffers } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
const StoreCategoriesContainer = ({ storeCategories, fallbackImage, ...rest }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("stores.page.details.productGroups.title")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(
    ProductOffers,
    {
      ...rest,
      offers: storeCategories,
      fallbackImage,
      labels
    }
  );
};
export {
  StoreCategoriesContainer as default
};
//# sourceMappingURL=StoreCategoriesContainer.js.map
